import { elem } from "./chrome";
import { skillIconNode } from "./itemicon";

/** `stats.Job` order, which is the original's `JOB_WARRIOR..JOB_SHAMAN`
 *  (`playersettingmodule.py:14-17`). */
export const JOB_WARRIOR = 0;
export const JOB_ASSASSIN = 1;
export const JOB_SURA = 2;
export const JOB_SHAMAN = 3;

export function jobForRace(race: number): number | null {
  switch (race) {
    case 0:
    case 4:
      return JOB_WARRIOR;
    case 1:
    case 5:
      return JOB_ASSASSIN;
    case 2:
    case 6:
      return JOB_SURA;
    case 3:
    case 7:
      return JOB_SHAMAN;
    default:
      return null;
  }
}

export const NEW_678TH_SKILL_ENABLE = false;

/** One job's two class trees, truncated to the eight cells the page has. */
export interface JobSkillGroups {
  readonly 1: readonly number[];
  readonly 2: readonly number[];
}

export const SKILL_INDEX_DICT_YMIR: Readonly<Record<number, JobSkillGroups>> = {
  [JOB_WARRIOR]: { 1: [1, 2, 3, 4, 5, 6, 0, 0], 2: [16, 17, 18, 19, 20, 21, 0, 0] },
  [JOB_ASSASSIN]: { 1: [31, 32, 33, 34, 35, 36, 0, 0], 2: [46, 47, 48, 49, 50, 51, 0, 0] },
  [JOB_SURA]: { 1: [61, 62, 63, 64, 65, 66, 0, 0], 2: [76, 77, 78, 79, 80, 81, 0, 0] },
  [JOB_SHAMAN]: { 1: [91, 92, 93, 94, 95, 96, 0, 0], 2: [106, 107, 108, 109, 110, 111, 0, 0] },
};

export const SKILL_INDEX_DICT_WEST: Readonly<Record<number, JobSkillGroups>> = {
  [JOB_WARRIOR]: { 1: [1, 2, 3, 4, 5, 0, 0, 0], 2: [16, 17, 18, 19, 20, 0, 0, 0] },
  [JOB_ASSASSIN]: { 1: [31, 32, 33, 34, 35, 0, 0, 0], 2: [46, 47, 48, 49, 50, 0, 0, 0] },
  [JOB_SURA]: { 1: [61, 62, 63, 64, 65, 66, 0, 0], 2: [76, 77, 78, 79, 80, 81, 0, 0] },
  [JOB_SHAMAN]: { 1: [91, 92, 93, 94, 95, 96, 0, 0], 2: [106, 107, 108, 109, 110, 111, 0, 0] },
};

export const SUPPORT_SKILL_INDEX_LIST_YMIR: readonly number[] = [
  122, 123, 121, 124, 125, 129, 0, 0, 130, 131, 141, 142,
];
export const SUPPORT_SKILL_INDEX_LIST_WEST: readonly number[] = [
  122, 123, 121, 124, 125, 129, 0, 0, 130, 131,
];

/** Whichever of the two tables this locale runs. See `NEW_678TH_SKILL_ENABLE`. */
export const SKILL_INDEX_DICT = NEW_678TH_SKILL_ENABLE
  ? SKILL_INDEX_DICT_YMIR
  : SKILL_INDEX_DICT_WEST;
export const SUPPORT_SKILL_INDEX_LIST = NEW_678TH_SKILL_ENABLE
  ? SUPPORT_SKILL_INDEX_LIST_YMIR
  : SUPPORT_SKILL_INDEX_LIST_WEST;

/** `ACTIVE_PAGE_SLOT_COUNT` / `SUPPORT_PAGE_SLOT_COUNT` (`uicharacter.py:47-48`). */
export const ACTIVE_PAGE_SLOT_COUNT = 8;
export const SUPPORT_PAGE_SLOT_COUNT = 12;

export const SKILL_GROUP_NAME_DICT: Readonly<Record<number, readonly [string, string]>> = {
  [JOB_WARRIOR]: ["Body", "Mental"],
  [JOB_ASSASSIN]: ["Blade", "Arc"],
  [JOB_SURA]: ["Weapon", "Magic"],
  [JOB_SHAMAN]: ["Dragon", "Healing"],
};

/** Name and icon for one previewed vnum. */
export interface PreviewSkill {
  readonly name: string;
  readonly icon: string;
}

export const PREVIEW_SKILLS: Readonly<Record<number, PreviewSkill>> = {
  1: { name: "Three-Way Cut", icon: "samyeon" },
  2: { name: "Sword Spin", icon: "palbang" },
  3: { name: "Berserk", icon: "jeongwi" },
  4: { name: "Aura of the Sword", icon: "geomgyeong" },
  5: { name: "Dash", icon: "tanhwan" },
  16: { name: "Spirit Strike (W)", icon: "gigongcham" },
  17: { name: "Bash", icon: "gyeoksan" },
  18: { name: "Stump", icon: "daejin" },
  19: { name: "Strong Body", icon: "cheongeun" },
  20: { name: "Sword Strike", icon: "geompung" },
  31: { name: "Ambush", icon: "amseup" },
  32: { name: "Fast Attack", icon: "gungsin" },
  33: { name: "Rolling Dagger", icon: "charyun" },
  34: { name: "Stealth", icon: "eunhyeong" },
  35: { name: "Poisonous Cloud", icon: "sangong" },
  46: { name: "Repetitive Shot", icon: "yeonsa" },
  47: { name: "Arrow Shower", icon: "gwangyeok" },
  48: { name: "Fire Arrow", icon: "hwajo" },
  49: { name: "Feather Walk", icon: "gyeonggong" },
  50: { name: "Poison Arrow", icon: "gigung" },
  61: { name: "Finger Strike", icon: "swaeryeong" },
  62: { name: "Dragon Swirl", icon: "yonggwon" },
  63: { name: "Enchanted Blade", icon: "gwigeom" },
  64: { name: "Fear", icon: "gongpo" },
  65: { name: "Enchanted Armour", icon: "jumagap" },
  66: { name: "Dispel", icon: "pabeop" },
  76: { name: "Dark Strike", icon: "maryeong" },
  77: { name: "Flame Strike", icon: "hwayeom" },
  78: { name: "Flame Spirit", icon: "muyeong" },
  79: { name: "Dark Protection", icon: "heuksin" },
  80: { name: "Spirit Strike (S)", icon: "tusok" },
  81: { name: "Dark Orb", icon: "geomhwan" },
  91: { name: "Flying Talisman", icon: "bipabu" },
  92: { name: "Shooting Dragon", icon: "yongpa" },
  93: { name: "Dragon's Roar", icon: "paeryong" },
  94: { name: "Blessing", icon: "hosin" },
  95: { name: "Reflect", icon: "boho" },
  96: { name: "Dragon's Strength", icon: "gicheon" },
  106: { name: "Lightning Throw", icon: "noejeon" },
  107: { name: "Summon Lightning", icon: "byeorak" },
  108: { name: "Lightning Claw", icon: "pokroe" },
  109: { name: "Cure", icon: "jeongeop" },
  110: { name: "Swiftness", icon: "kwaesok" },
  111: { name: "Attack Up", icon: "jeungryeok" },
  121: { name: "Leadership", icon: "tongsol" },
  122: { name: "Combo", icon: "combo" },
  124: { name: "Mining", icon: "mining" },
  125: { name: "Item Creation", icon: "making" },
  129: { name: "Polymorph", icon: "polymorph" },
  130: { name: "Horse Riding", icon: "riding" },
  131: { name: "Call Horse", icon: "summon" },
};

/** One cell of the group-0 preview: a vnum with a picture, or an empty cell. */
export interface PreviewCell {
  readonly vnum: number;
  readonly name: string;
  readonly icon: string;
}

export interface SkillGroupPreview {
  /** `Skill_Active_Slot`'s eight, in `SKILL_INDEX_DICT` order. */
  readonly active: readonly (PreviewCell | null)[];
  /** `Skill_ETC_Slot`'s twelve, in `"SUPPORT"` order. */
  readonly support: readonly (PreviewCell | null)[];
  /** The two `SKILL_GROUP_NAME_DICT` labels, button 1 then button 2. */
  readonly groupNames: readonly [string, string];
}

function cellFor(vnum: number): PreviewCell | null {
  if (vnum === 0) return null;
  const row = PREVIEW_SKILLS[vnum];
  if (row === undefined) return null;
  return { vnum, name: row.name, icon: row.icon };
}

function pad(
  list: readonly number[],
  count: number,
): readonly (PreviewCell | null)[] {
  const cells: (PreviewCell | null)[] = [];
  for (let i = 0; i < count; i++) cells.push(cellFor(list[i] ?? 0));
  return cells;
}

export function skillGroupPreview(job: number, group: 1 | 2): SkillGroupPreview | null {
  const trees = SKILL_INDEX_DICT[job];
  const names = SKILL_GROUP_NAME_DICT[job];
  if (trees === undefined || names === undefined) return null;
  return {
    active: pad(trees[group], ACTIVE_PAGE_SLOT_COUNT),
    support: pad(SUPPORT_SKILL_INDEX_LIST, SUPPORT_PAGE_SLOT_COUNT),
    groupNames: names,
  };
}

/**
 * The page a character who has chosen no skill group is shown: the two group
 * buttons and both greyed cell grids behind them.
 *
 * `__SelectSkillGroup(index)` presses one `skillGroupButton` down -- a
 * `radio_button`, so the pressed state is the whole feedback the original
 * gives -- and repaints `Skill_Active_Slot` and `Skill_ETC_Slot` from
 * `SKILL_INDEX_DICT` (`uicharacter.py:1165-1200`). Nothing here is a request:
 * the group is chosen by walking to a teacher (`skill_group.quest:109`), and
 * this page is what the choice would buy.
 */
export function skillGroupPageNode(
  preview: SkillGroupPreview,
  group: 1 | 2,
  doc: Document,
  onSelectGroup: (group: 1 | 2) => void = () => {},
): HTMLElement {
  const page = elem(doc, "div", "skill-group-page");
  const row = elem(doc, "div", "skill-group-buttons");
  for (const index of [0, 1] as const) {
    const button = doc.createElement("button");
    button.type = "button";
    button.className = "skill-group-button";
    button.textContent = preview.groupNames[index];
    button.dataset.group = String(index + 1);
    button.setAttribute("aria-pressed", String(group === index + 1));
    button.addEventListener("click", () => onSelectGroup(index === 0 ? 1 : 2));
    row.append(button);
  }
  page.append(
    row,
    previewSection("Active", preview.active, doc, ACTIVE_PAGE_SLOT_COUNT * 3),
    previewSection("Support", preview.support, doc, SUPPORT_PAGE_SLOT_COUNT),
  );
  return page;
}

/** One grid of greyed cells: what the group would grant, unlearnable until it
 *  is chosen. `minCells` keeps the page's own shape when the table is shorter
 *  than the board (`characterwindow.py:605-667`). */
function previewSection(
  label: string,
  cells: readonly (PreviewCell | null)[],
  doc: Document,
  minCells: number,
): HTMLElement {
  const section = elem(doc, "div", "skill-section");
  section.append(elem(doc, "span", "skill-section-label", label));
  const row = elem(doc, "div", label === "Support" ? "skill-grid-support" : "skill-grid");
  for (const cell of cells) {
    const node = elem(doc, "div", "skill m2-slot skill-unlearned skill-greyed");
    if (cell === null) {
      node.setAttribute("aria-hidden", "true");
      row.append(node);
      continue;
    }
    node.dataset.vnum = String(cell.vnum);
    node.setAttribute("aria-disabled", "true");
    node.title = cell.name;
    // Grade 0 is the picture the original draws at level 0 (`skillGradeFor`),
    // through the same `skill_icons.png` path every other slot uses.
    const art = skillIconNode(cell.icon, 0, doc);
    if (art !== null) node.append(art);
    node.append(elem(doc, "span", "skill-name", cell.name));
    row.append(node);
  }
  for (let index = cells.length; index < minCells; index += 1) {
    const empty = elem(doc, "div", "skill m2-slot skill-unlearned");
    empty.setAttribute("aria-hidden", "true");
    row.append(empty);
  }
  section.append(row);
  return section;
}
